export const LogoutPath = '/logout';
